import * as v from 'valibot';
import type { FieldDefinition } from '@v2/components/SchemaForm/types';

export const accountSchema = v.object({
  firstName: v.pipe(v.string(), v.minLength(1, 'First name is required')),
  lastName: v.pipe(v.string(), v.minLength(1, 'Last name is required')),
  email: v.pipe(v.string(), v.minLength(1, 'Email is required'), v.email('Invalid email address')),
  roleId: v.pipe(v.string(), v.minLength(1, 'Role is required')),
  idpObjectId: v.pipe(v.string(), v.minLength(1, 'Azure ID is required')),
});

export type AccountFormValues = v.InferOutput<typeof accountSchema>;

export const accountFields: FieldDefinition[] = [
  { name: 'firstName', label: 'First Name', type: 'text', placeholder: 'First', colSpan: 1 },
  { name: 'lastName', label: 'Last Name', type: 'text', placeholder: 'Last', colSpan: 1 },
  { name: 'email', label: 'Email Address', type: 'email', placeholder: 'Email', colSpan: 1 },
  { name: 'roleId', label: 'Role', type: 'select', placeholder: 'Select a role', colSpan: 1 },
  {
    name: 'idpObjectId',
    label: 'Azure ID',
    type: 'text',
    placeholder: '(ie. 3470ff3b-1d66-418a-a7ac-547ce662d277)',
    colSpan: 2,
  },
];
